  const encryptedRoutes: string[] =['/api/auth/login'];
  export default encryptedRoutes